<template>

  <loginHome>
    <div slot="titleRight">
      <div class="titleBtn">
        <div class="titleBtnItem" @click="toPage('/memberLogin')">返回登录</div>
      </div>
    </div>
    <div slot="content">
      <div class="contentBox">
        <el-steps :active="active" align-center>
          <el-step title="填写手机号"></el-step>
          <el-step title="验证身份"></el-step>
          <el-step title="设置新密码"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
        <div class="input-box" v-show="active<=2">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
            <el-form-item prop="userName" label="注册手机号" v-show="active===0">
              <el-input type="text" v-model="ruleForm.userName" placeholder="请输入手机号">

              </el-input>
            </el-form-item>
            <el-form-item prop="phoneCode" label="验证码" v-show="active===1">
              <el-input type="text" v-model="ruleForm.phoneCode" placeholder="请输入验证码">
                <div slot="suffix" class="get-code" @click="sendCode">{{codeText}} <span
                  v-if="typeof codeText === 'number'">秒</span></div>
              </el-input>
            </el-form-item>
            <el-form-item prop="userPass" label="新密码" v-show="active===2">
              <el-input type="password" v-model="ruleForm.userPass" placeholder="请输入新密码">

              </el-input>
            </el-form-item>
            <el-form-item prop="ruserPass" label="确认新密码" v-show="active===2">
              <el-input type="password" v-model="ruleForm.ruserPass" placeholder="请确认新密码">

              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="active===3" class="set-ok">
          <div><i class="iconfont icondui"></i></div>
          <p class="tishi1">重置密码成功</p>
          <p class="tishi2">请使用新密码登录</p>
          <el-button type="primary" style="display:block;width: 300px;margin: 0 auto;" @click="toPage('/memberLogin')">返回登录</el-button>
        </div>
        <el-button v-show="active<=2" type="primary" style="display:block;width: 300px;margin: 0 auto;" @click="next">下一步</el-button>
      </div>
    </div>
  </loginHome>
</template>

<script>
  import loginHome from '../loginHome'

  export default {
    data() {
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'))
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass')
          }
          callback()
        }
      }
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.ruleForm.userPass) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        active: 0,
        codeText: '发送验证码', // 验证码文字
        id: null, // 计时器id
        timeId: null, // 一次性计时器id
        ruleForm: {
          userName: '', // 手机号
          phoneCode: '', // 验证码
          userPass: '', // 密码
          ruserPass: '' // 第二遍密码
        },
        getCode:123456,
        rules: {
          userName: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {min: 11, max: 11, message: '请输入正确的手机号', trigger: 'blur'}
          ],
          phoneCode: [
            {required: true, message: '请输入手机验证码', trigger: 'blur'},
            {min: 6, max: 6, message: '请输入手机验证码', trigger: 'blur'}
          ],
          userPass: [
            {validator: validatePass, trigger: 'blur'},
            {required: true, message: '请输入新密码', trigger: 'blur'},
          ],
          ruserPass: [
            {validator: validatePass2, trigger: 'blur'},
            {required: true, message: '请再次输入新密码', trigger: 'blur'},
          ]
        }
      };
    },

    methods: {
      next() {
        if(this.active === 0){
          if(!this.$tools.checkTel(this.ruleForm.userName)){
            this.active++
          }
        }else if(this.active === 1){
          if(!this.$tools.checkCode(this.ruleForm.phoneCode) && Number(this.ruleForm.phoneCode) === this.getCode){
            this.active++
          }else{
            this.$message('请输入正确的验证码')
          }
        }else if(this.active === 2){
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              this.$api.apiLogin.sebmitFromMember({
                userType:1,
                userName:this.ruleForm.userName,
                phoneCode:this.ruleForm.phoneCode,
                newPassword:this.$md5(this.ruleForm.userPass),
                rnewPassword:this.$md5(this.ruleForm.ruserPass)
              }).then(()=>{
                this.active++
              }).catch(e=>{
                this.$message(e.info)
                })
            } else {
              return false;
            }
          });
        }else if(this.active === 3){
          this.$router.push('/memberLogin')
        }
      },
      toPage(router){
        this.$router.push(router)
      },
      sendCode() {
        this.$refs.ruleForm.validateField('userName', (valid) => {
          if (!valid) {
            // 发送ajax
            if (this.codeText === '发送验证码' || this.codeText === '重新发送') {
              this.codeText = 60
              this.id = setInterval(() => {
                if (this.codeText === 0) {
                  this.codeText = '重新发送'
                  return
                }
                if (typeof this.codeText === 'number') {
                  this.codeText--
                }
              }, 1000)
              console.log(111)
              this.$api.apiLogin.sendPhoneCode({
                userName: this.ruleForm.userName,
                type: 2,
                userType:1
              }).then(res=>{
                this.getCode = res.data.phonecode  // 540167
              }).catch(e=>{
                if(e.status === 301){
                  this.$message(e.info)
                  this.active = 0
                  this.codeText = 0
                  this.codeText = '重新发送'
                }else{
                  this.$message(e.info)
                  this.codeText = '重新发送'
                  return
                }
              })
            }
          }
        })
      },
    },
    beforeDestroy() {
      if (this.id) {
        clearInterval(this.id)
      }
      if (this.timeId) {
        clearTimeout(this.timeId)
      }
    },
    watch: {
      codeText() {
        if (this.codeText === '重新发送') {
          if (this.id) {
            clearInterval(this.id)
          }
        }
      }
    },
    components: {
      loginHome
    }
  }
</script>

<style scoped lang="scss">
  .titleBtn {
    width: 250px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .titleBtnItem {
      font-size: 18px;
      background: #00a2ea;
      color: #fff;
      padding: 10px;
      border-radius: 6px;
      cursor: pointer;
    }
  }

  .contentBox {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1200px;
    height: 500px;
    padding: 60px 60px 20px 60px;
    background: #ffffff;

    .input-box {
      width: 500px;
      padding: 50px 0;
      margin: 0 auto;
    }

    .get-code {
      color: #00a2ea;
      line-height: 45px;
      cursor: pointer;
      &.active {
        color: #999;
      }
    }
    .set-ok{
      padding: 50px;
      div{
        text-align: center;
        margin-bottom: 20px;
        i{
          font-size: 100px;
          color: #00a2ea;
        }
      }
      .tishi1{
        line-height: 40px;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
      }
      .tishi2{
        line-height: 40px;
        font-size: 14px;
        color: #999;
        text-align: center;
        margin-bottom: 20px;
      }
    }
  }
</style>